"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoriesErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.getCategoriesErrors = [
    UseCaseError_1.UseCaseError.create('problemInProcess'),
    UseCaseError_1.UseCaseError.create('invalidData'),
    UseCaseError_1.UseCaseError.create('notFound')
];
//# sourceMappingURL=getCategoriesErrors.js.map